module.exports = __webpack_public_path__ + "img/create_campaign.ca1053d7.svg";